module.exports = __webpack_public_path__ + "static/media/pocket.b80afd3e.webp";